import { c as _c } from "react/compiler-runtime";
import { SubscriptionPriceBoxNoticeData, useSubscriptionPriceBoxNotice } from '@udemy-v2/notices';
import React, { createContext, ReactNode, useContext, useMemo } from 'react';
import { useConsumerSubscriptionPlan } from '@udemy-v2/subscription-graphql';
import { useInterpolatedSubscriptionNotice } from '@/features/course-landing-page/components/subscription-notice/subscription-notice';
export interface CLPNoticeContext {
  subscriptionPriceBoxNoticeData?: SubscriptionPriceBoxNoticeData;
}
export const ReactCLPNoticeContext = createContext<CLPNoticeContext | undefined>(undefined);
interface ReactClpNoticeContextProviderProps {
  children: ReactNode;
}
export const ClpNoticeContextProvider: React.FC<ReactClpNoticeContextProviderProps> = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const {
    notices
  } = useSubscriptionPriceBoxNotice();
  const subscriptionPlan = useConsumerSubscriptionPlan();
  const rawNotice = notices.length ? notices[0].data : undefined;
  const interpolatedNotice = useInterpolatedSubscriptionNotice(subscriptionPlan && "id" in subscriptionPlan ? subscriptionPlan : undefined, rawNotice);
  let t1;
  bb0: {
    if (interpolatedNotice) {
      let t2;
      if ($[0] !== interpolatedNotice) {
        t2 = {
          subscriptionPriceBoxNoticeData: interpolatedNotice
        };
        $[0] = interpolatedNotice;
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      t1 = t2;
      break bb0;
    }
    t1 = undefined;
  }
  const contextValue = t1;
  let t2;
  if ($[2] !== children || $[3] !== contextValue) {
    t2 = <ReactCLPNoticeContext.Provider value={contextValue}>{children}</ReactCLPNoticeContext.Provider>;
    $[2] = children;
    $[3] = contextValue;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export function useClpNoticeContext() {
  return useContext(ReactCLPNoticeContext);
}